import useShouldRenderHiddenIframe from './useShouldRenderHiddenIframe';

export default useShouldRenderHiddenIframe;
